export { DailyInspection } from './DailyInspection';
